import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { InspectionDetailList, InspectionSearch, GetInvoiceNo4IQCResult, InspectionTypeSearch, GetInspectionResultResult, InspectionH, SamplingSearch, InspectionD, InspectionEdit, InspectionHeaderList, GetSamplingDetail4SQEResult, InspectionItem4SQESearch, SQEInspectionH, GetInvoiceNo4SQEResult } from "../model/inspection.model";
import { ReturnApi } from "../model/common.model";
import { InventorySearch, InventoryDetailList, InventoryDetail, StockBalance } from "../model/inventory";
import { SalesOrder } from "../model/shipping.model";


const API_URL = environment.apiUrl;
const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};

@Injectable()
export class InventoryService {
  private Url = '';  // URL to web api
  currentUser: any;

  constructor(
    private http: HttpClient) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    console.log(this.currentUser);
    this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/Inventory';

  }

  getInventoryList(search: InventorySearch): Observable<InventoryDetailList[]> {
    return this.http.post<InventoryDetailList[]>(this.Url + "/GetInventoryMovementSummaryReport", search, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }
  getInventoryDetailList(search: InventorySearch): Observable<InventoryDetail[]> {
    return this.http.post<InventoryDetail[]>(this.Url + "/GetInventoryMovementDetailReport", search, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }
  getStockbalanceList(search: InventorySearch): Observable<StockBalance[]> {
    return this.http.post<StockBalance[]>(this.Url + "/GetInventoryBalance", search, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }

  GetInventoryMovementSummaryForExport(search: InventorySearch, type: number): Observable<any> {

    return this.http.post(this.Url + '/GetInventoryMovementSummaryForExport/' + type, search, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      }),
      responseType: 'arraybuffer'
    }).pipe(tap((x) => {
    }),
      catchError(this.handleError<InventorySearch>('SearchWorkPermit'))
    );
  }
  GetInventoryMovementDetailForExport(search: InventorySearch, type: number): Observable<any> {

    return this.http.post(this.Url + '/GetInventoryMovementDetailForExport/' + type, search, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      }),
      responseType: 'arraybuffer'
    }).pipe(tap((x) => {
    }),
      catchError(this.handleError<InventorySearch>('SearchWorkPermit'))
    );
  }
  GetInventoryBalanceForExport(search: InventorySearch, type: number): Observable<any> {

    return this.http.post(this.Url + '/GetInventoryBalanceForExport/' + type, search, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      }),
      responseType: 'arraybuffer'
    }).pipe(tap((x) => {
    }),
      catchError(this.handleError<InventorySearch>('SearchWorkPermit'))
    );
  }
  GetInventoryTransactionByLocExport(data: SalesOrder): Observable<any> {

    return this.http.post(this.Url + '/GetInventoryTransactionByLocExport/', data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      }),
      responseType: 'arraybuffer'
    }).pipe(tap((x) => {
    }),
      catchError(this.handleError<{}>('SearchWorkPermit'))
    );
  }


  /**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a ScgCompanyService message with the MessageService */
  private log(message: string) {
    console.log(message);
    // this.messageService.add('ScgCompanyService: ' + message);
  }




}


// WEBPACK FOOTER //
// ./src/app/services/inventory.service.ts